// extracted by mini-css-extract-plugin
module.exports = {"root":"settingsPopover_root__3msYF","popoverItem":"settingsPopover_popoverItem__X59Fn","icon":"settingsPopover_icon__2Q-bl"};